import React from "react";
import { getUserToken } from "../../service/AuthService";
import { Navigate, Outlet } from "react-router-dom";

const PublicRoute = () => {
  const auth = getUserToken();

  // If authorized, return user account
  // If not, return element that will navigate to login page
  return !auth ? <Outlet /> : <Navigate to="/pass-account" />;
};
export default PublicRoute;
